import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Svg } from "../svg/Svg";
export const TextOptionIcon = React.forwardRef((props, ref) => (_jsxs(Svg, { "data-testid": "TextOptionIcon", ...props, ref: ref, children: [_jsx("path", { fill: "currentColor", d: "M8.682,0l5.882,13H13L11.485,9.589H4.46L2.929,13H1.435L7.318,0Zm2.231,8.279L7.982,1.7,5.031,8.279Z" }), _jsx("polygon", { fill: "currentColor", points: "1 16 15 16 15 15 1 15 1 16" })] })));
TextOptionIcon.displayName = "TextOptionIcon";
